import SimpleCrudList from "../../components/crud/SimpleCrudList";

interface TripIssue {
  id: string;
  issueType: string;
  description: string;
  status: string;
  priority: string;
}

export default function TripIssues() {
  return (
    <SimpleCrudList<TripIssue>
      title="Trip Issues"
      apiPath="/trip-issues"
      baseRoute="/trip-issues"
      searchKeys={["issueType", "description", "status"]}
      columns={[
        { key: "issueType", label: "Type" },
        { key: "description", label: "Description" },
        { key: "status", label: "Status" },
        { key: "priority", label: "Priority" },
      ]}
      addLabel="Add Issue"
    />
  );
}
